import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
  refundAffirm,
  findPurchase,
  completeWithAch,
  recalculateShipping,
} from 'actions/purchases';
import { getRefundAffirmErrorMessage } from 'reducers';
import purchasePage from 'decorators/purchasePage';
import Purchase from 'components/Purchase/Purchase';
import FormError from 'components/FormError';
import SendPurchaseInvoiceButton from 'components/SendPurchaseInvoiceButton/SendPurchaseInvoiceButton';
import ChargePurchase from 'components/ChargePurchase/ChargePurchase';
import withPurchaseMethods from 'decorators/withPurchaseMethods';
import withCycles from 'decorators/withCycles';
import SplitPayment from 'components/SplitPayment/SplitPayment';
import LinkedPurchases from 'components/LinkedPurchases/LinkedPurchases';
import CancelPurchaseInvoice from 'components/CancelPurchaseInvoice/CancelPurchaseInvoice';
import RefundPurchaseButton from 'components/RefundPurchaseButton';
import RefundPurchaseButtonModal from 'components/RefundPurchaseButton/RefundPurchaseButtonModal';
import GenerateRenewalInvoiceButton from 'components/GenerateRenewalInvoiceButton/GenerateRenewalInvoiceButton';
import PaymentArrangementApproval from 'components/PaymentArrangementApproval/PaymentArrangementApproval';
import AdjustmentCredit from 'components/AdjustmentCredit/AdjustmentCredit';
import RollingArrangementList from 'components/RollingArrangementList/RollingArrangementList';
import { canAdjust, canCancel, canCharge } from 'helpers/viewPurchase';
import RedirectMessage from 'components/RedirectMessage/RedirectMessage';
import OrdersList from 'components/Orders/OrdersList';
import withPendingArrangementAgent from '../decorators/withPendingArrangementAgent';
import withActiveRollingArrangement from '../decorators/withActiveRollingArrangement';
import CompleteAchPurchaseButton from '../components/Purchase/CompleteAchPurchaseButton';
import RefundPurchase from 'components/RefundPurchase';
// import creditPage from 'decorators/creditPage';
import PurchaseTaxesModal from 'components/modals/PurchaseTaxesModal';

class ViewPurchase extends Component {
  constructor(props) {
    super(props);

    this.openRefundPurchaseButtonModal =
      this.openRefundPurchaseButtonModal.bind(this);

    this.state = {
      isModalOpen: false,
      recalculatingShipping: false,
      recalculateShippingSuccess: false,
      recalculateShippingError: '',
    };
  }

  get isChargeTypePayTomorrow() {
    const { purchase } = this.props;

    if (!purchase) return false;
    return purchase.charge_type === 'paytomorrow';
  }

  get isCompleted() {
    const { purchase } = this.props;

    if (!purchase) return false;
    return purchase.status === 'complete';
  }

  get showRefundButton() {
    const { purchase, isAdminOrBilling } = this.props;
    if (!purchase) return false;
    return (
      this.isCompleted &&
      ['affirm', 'affirm2'].includes(purchase.charge_type) &&
      isAdminOrBilling
    );
  }

  async openRefundPurchaseButtonModal(refundType) {
    const {
      refundAffirm,
      findPurchase,
      purchase: { id, charge_id },
    } = this.props;
    this.setState({ isModalOpen: true });

    const confirmResult = await RefundPurchaseButtonModal({
      open: this.state.isModalOpen,
    });

    if (!confirmResult) {
      this.setState({ isModalOpen: false });
      return;
    }

    const response = await refundAffirm(id, charge_id, refundType);

    if (response && response.status === 200) {
      await findPurchase(id);
    } else {
      this.setState({ error: this.props.refundError });
    }

    this.setState({ isModalOpen: false });
  }

  recalculateShipping = async () => {
    const { recalculateShipping, purchase } = this.props;
    this.setState({
      recalculatingShipping: true,
      recalculateShippingSuccess: false,
      recalculateShippingError: '',
    });
    try {
      await recalculateShipping(purchase.id);
      this.setState(
        {
          recalculatingShipping: false,
          recalculateShippingSuccess: true,
          recalculateShippingError: '',
        },
        () =>
          setTimeout(
            () => this.setState({ recalculateShippingSuccess: false }),
            25000,
          ),
      );
    } catch (e) {
      const errMessage =
        e.errors &&
        e.errors._error &&
        (e.errors._error.status ||
          e.errors._error.details ||
          e.errors._error.detail);
      this.setState({
        recalculatingShipping: false,
        recalculateShippingSuccess: false,
        recalculateShippingError: errMessage,
      });
    }
  };

  render() {
    const {
      purchase,
      notFound,
      subs,
      orders,
      user,
      paymentMethods,
      isAdmin,
      isAdminOrManagerOrBilling,
      cycles,
      pendingArrangementAgent,
      activeRollingArrangement,
      completeWithAch,
      lineItems,
      lineItemsPage,
      lineItemsCount,
      findPurchase,
      qsSearch,
    } = this.props;
    const {
      error,
      recalculateShippingSuccess,
      recalculatingShipping,
      recalculateShippingError,
    } = this.state;
    if (notFound) {
      return <div>Not Found</div>;
    }

    if (!purchase || !user) {
      return <div>Loading...</div>;
    }

    const isPhoneOrRouter = lineItems.some(
      (item) =>
        item.prod_category === 'phone' || item.prod_category === 'router',
    );
    const isPendingArrangement = purchase.status === 'pending_arrangement';
    const isPending = purchase.status === 'pending';
    const isOverdue = purchase.status === 'overdue';
    const isOpen = purchase.status === 'open';
    const isComplete = purchase.status === 'complete';
    const canTransferLine = isAdmin && (isPending || isOverdue || isOpen);
    const isPaymentMethodExists = Boolean(
      paymentMethods && paymentMethods.length,
    );
    const isRefundPurchase = purchase.purchase_type === 'refund';

    return (
      <div>
        <RedirectMessage />
        {isAdminOrManagerOrBilling && isPendingArrangement && (
          <PaymentArrangementApproval
            user={user}
            purchaseId={purchase.id}
            findPurchase={findPurchase}
          />
        )}
        <div className="d-flex-vc">
          <GenerateRenewalInvoiceButton userId={purchase.user_profile} />
          <PurchaseTaxesModal purchaseId={purchase.id} />
        </div>
        <Purchase
          user={user}
          purchase={purchase}
          subs={subs}
          pendingArrangementAgent={pendingArrangementAgent}
          lineItems={lineItems}
          lineItemsPage={lineItemsPage}
          lineItemsCount={lineItemsCount}
          qsSearch={qsSearch}
        />
        <LinkedPurchases purchase={purchase} />
        {activeRollingArrangement && (
          <React.Fragment>
            <h4>Rolling Payment Arrangement</h4>
            <RollingArrangementList
              rollingArrangements={[activeRollingArrangement]}
            />
            <br />
          </React.Fragment>
        )}
        <SendPurchaseInvoiceButton
          purchaseId={purchase.id}
          email={user.email}
        />
        {!isComplete && (
          <React.Fragment>
            <div className="mar-t">
              <Link to={`/purchases/${purchase.id}/payment-arrangement`}>
                <button type="button" className="btn btn-primary">
                  Create Payment Arrangement
                </button>
              </Link>
            </div>
            {isAdmin && (
              <CompleteAchPurchaseButton
                completeWithAch={completeWithAch}
                purchaseId={purchase.id}
              />
            )}
            <div className="mar-t">
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.recalculateShipping}
                disabled={recalculatingShipping}
              >
                Recalculate Shipping
              </button>
              {recalculateShippingSuccess && (
                <div className="mar-t text-success">Successfully completed</div>
              )}
              {recalculateShippingError && (
                <div className="mar-t text-danger">
                  {recalculateShippingError}
                </div>
              )}
            </div>
          </React.Fragment>
        )}
        {canTransferLine ? (
          <div className="mar-t">
            <Link to={`/purchases/${purchase.id}/transfer-line-items`}>
              <button type="button" className="btn btn-primary">
                Transfer Line Item
              </button>
            </Link>
          </div>
        ) : null}
        {!isPaymentMethodExists && (
          <div className="mar-t">
            <Link to={`/users/${user.id}/payment-methods`}>
              <button type="button" className="btn btn-primary">
                Add Card
              </button>
            </Link>
          </div>
        )}
        {canCharge(purchase) ? (
          <React.Fragment>
            <ChargePurchase
              purchaseId={purchase.id}
              cards={paymentMethods}
              requiresCSV={isPhoneOrRouter && !isAdmin}
            />
            <SplitPayment purchase={purchase} />
          </React.Fragment>
        ) : null}
        <div className="mar-t">
          {canCancel(purchase, cycles) && isAdmin && (
            <CancelPurchaseInvoice
              findPurchase={findPurchase}
              purchaseId={purchase.id}
              className="mr-10"
            />
          )}
          {this.showRefundButton && (
            <RefundPurchaseButton
              isChargeTypePayTomorrow={this.isChargeTypePayTomorrow}
              handleClick={this.openRefundPurchaseButtonModal}
            />
          )}
        </div>
        <div className="mar-t">
          {canAdjust(purchase) && isAdmin && (
            <AdjustmentCredit
              purchaseId={purchase.id}
              userProfile={purchase.user_profile}
              amount={purchase.cost.amount}
            />
          )}
        </div>
        <RefundPurchase
          showRefund={isComplete && isAdmin && !isRefundPurchase}
          purchaseId={purchase.id}
        />
        {error && <FormError error={error} />}
        {Boolean(orders.length) && isAdmin && <OrdersList orders={orders} />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    refundError: getRefundAffirmErrorMessage(state),
    findPurchase,
  };
};

const mapDispatchToProps = {
  refundAffirm,
  findPurchase,
  completeWithAch,
  recalculateShipping,
};

export default compose(
  purchasePage,
  withPurchaseMethods,
  withCycles,
  withPendingArrangementAgent,
  withActiveRollingArrangement,
  connect(mapStateToProps, mapDispatchToProps),
)(ViewPurchase);
